import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { PermissionsComponent } from './PermissionsComponent.js';
import { _className } from '@nu-art/thunderstorm-frontend/index';
import { resolveContent } from '@nu-art/ts-common';
export class PermissionsEditableComponent extends PermissionsComponent {
    deriveStateFromProps(nextProps, state) {
        state.forceLock = nextProps.forceLock;
        return state;
    }
    renderFallback = () => {
        if (!this.props.value)
            return _jsx(_Fragment, {});
        const className = _className('permissions-editable__value', this.props.className);
        return _jsx("div", { className: className, style: this.props.style, children: resolveContent(this.props.value) });
    };
    renderPermitted = () => {
        if (this.props.forceLock)
            return this.renderFallback();
        return _jsx(_Fragment, { children: this.props.children });
    };
}
//# sourceMappingURL=PermissionsEditableComponent.js.map